import { render, staticRenderFns } from "./aktivenKindergruppen.vue?vue&type=template&id=4174383a&"
import script from "./aktivenKindergruppen.vue?vue&type=script&lang=js&"
export * from "./aktivenKindergruppen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports